import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=bff673cc&"
import script from "./LoadingPage.vue?vue&type=script&lang=ts&"
export * from "./LoadingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports